import QuestionsHelper from '~/components/Questionnaires/QuestionsHelper'
import { updateField, getField } from 'vuex-map-fields'

const getDefaultState = () => ({
  inspectorMode: 'questionnaire'
})

export const state = getDefaultState

export const mutations = {
  resetState(state) {
    Object.assign(state, getDefaultState())
  },
  setStateFromResponse(state, { question }) {
    QuestionsHelper.setState(state, question)
  },
  updateField
}

export const getters = {
  getField,
}

export const actions = {
  async init({ dispatch }, params) {
    dispatch('questions/editQuestions/init', {params, questionControllerName: 'audit_inspector_signature_question', name: 'inspectorSignature'}, { root: true })
  },
  async configureParams({ commit }, params) {
    commit("questions/editQuestions/setWeightAttributesOn", params, { root: true })
  },
  async configureInitState({ dispatch }) {},
}